import type { APIPaginatedResponse, ID } from "../api";
import type { Slot } from "./slots";

export enum OrderType {
  Table = 0,
  Collect = 1,
  Delivery = 2,
  CounterService = 3,
  TableSessions = 4,
}

export enum OrderFlow {
  Payment = 0,
  EPOS = 1,
}

export interface Order {
  allergy_alerts: Array<IAllergyAlert>;
  session_allergy_alerts: Array<IAllergyAlert>;
  delivery_address: {
    city: string;
    address_line_two: string;
    postcode: string;
    address_line_one: string;
    id: ID;
  };
  device_name: string;
  collection_time: null | string;
  offline_mode: boolean;
  comment: null | string;
  contains_item_types: number[];
  created_at: string;
  delivery_postcode: null | string;
  partially_refunded: boolean;
  partially_voided: boolean;
  delivery_time: null | string;
  email: null | string;
  estimated_delivery_time: null | string;
  id: ID;
  identifier: string;
  name: null | string;
  number_of_items: number;
  order_flow: OrderFlow;
  order_number: string;
  order_type: number;
  outstanding_balance: number;
  slot: Slot | null;
  slot_session_id: number;
  status: number;
  total_amount: number;
  voucher_tab_amount: number;
  discount_amount: number;
  updated_at: string;
  original_amount: number;
  special_requests: string;
  phone_number: string;
}

export interface IAllergyAlert {
  id: number;
  name: string;
  order: number;
}
